import { Field, Form, Formik } from "formik";
import config from "../../../config/config";
import { Link } from "react-router-dom";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { checkUserPermission } from "../../../common/UserPermission";
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { toastError, toastSuccess } from "../../../common/Toast";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  ERROR_EXISTS,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../common/Constant";
import * as Yup from "yup";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Select from "react-select";

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "add-master-register";
let PERMISSION_EDIT = "add-master-register";
let PERMISSION_DELETE = "add-master-register";

const MasterRegister = (props) => {
  const MySwal = withReactContent(Swal);
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const location = localStorage.getItem("Location");
  const [formValues, setFormValues] = useState({
    ID: 0,
    Name: "",
    Location: 0,
    isdelete: 0,
  });
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowSelectData, setRowSelectData] = useState([]);
  const [locationDropdown, setLocationDropdown] = useState([]);
  const [rowSelection, setRowSelection] = useState({});

  const validationSchema = Yup.object().shape({
    Name: Yup.string().required("Brand name is required"),
  });

  let parentbrandoption = [];
  const itemkits = data.map((u, i) => {
    parentbrandoption[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  useEffect(() => {
    const result = Object.keys(rowSelection).map(Number);
    setRowSelectData(result);
  }, [rowSelection]);

  useEffect(() => {
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  let locationDropdownOption = [];
  const Dropdown = locationDropdown.map((u, i) => {
    locationDropdownOption[i] = { label: u.Name, value: u.Id };
  });

  const handleLocationChnage = (e) => {
    setFormValues({ ...formValues, Location: e.value });
  };

  const handleInputChange = (e) => {
    setFormValues({ ...formValues, Name: e.target.value });
  };

  // Get all Brand data
  const handleListData = () => {
    setLoading(true);

    axios
      .get(
        `${config.employeesBaseUrl}/employees/getmasterregisters?locationid=${location}`, //pagination?.pageSize
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setData(res.data.ResponseData);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
    setLoading(false);
  };

  useEffect(() => {
    handleListData();
  }, []);

  const handleUpdate = (pID) => {
    setLoading(true);
    axios
      .get(
        `${config.employeesBaseUrl}/employees/getmasterregistersbyid?id=${pID}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const apiData = res.data.ResponseData[0];
        const data = {
          ID: apiData.ID,
          Name: apiData.Name,
          Location: apiData.LocationId,
        };
        setFormValues(data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleSubmit = async (eventObject) => {
    axios
      .post(
        `${config.employeesBaseUrl}/employees/masterregisterupsert`,
        {
          id: eventObject.ID,
          name: eventObject.Name,
          locationid: eventObject.Location,
          loginuserid: loginUserId,
          isdelete: eventObject.isdelete,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          handleListData();
          setLoading(false);
          //   window.location.reload();
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);

          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
        setLoading(false);
      });
  };

  // Delete Brand
  const handleDeletePopup = (pID) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "Are You Sure, You want to delete",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, confirm it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleSubmit({
          ID: pID,
          Name: "",
          locationid: location,
          loginuserid: loginUserId,
          isdelete: 1,
        });
      } else {
        MySwal.close();
      }
    });
  };

  const handleManageDataPopup = () => {
    setFormValues({
      ID: 0,
      Name: "",
      Location: 0,
    });
  };

  const columns = useMemo(() => [
    {
      header: "Id",
      accessorKey: "ID",
    },
    {
      header: "Name",
      accessorKey: "Name",
    },
    {
      header: "Location",
      accessorKey: "Location",
    },
  ]);

  const [columnOrder, setColumnOrder] = useState(
    ["mrt-row-select", ...columns.map((c) => c.accessorKey), "mrt-row-actions"] //array of column ids (Initializing is optional as of v2.10.0)
  );

  const renderRowActions = ({ row }) => {
    return (
      <div>
        {checkUserPermission(PERMISSION_EDIT) && (
          <Link
            className="btn btn-primary"
            to="#"
            data-bs-toggle="modal"
            data-bs-target="#ManageDataModal"
            data-backdrop="static"
            data-keyboard="false"
            onClick={() => handleUpdate(row.original.ID)}
          >
            Edit
          </Link>
        )}
        {checkUserPermission(PERMISSION_DELETE) && (
          <Link
            className="btn btn-sm btn-secondary confirm-text ml-2"
            to="#"
            title="Delete"
            onClick={() => handleDeletePopup(row.original.ID)}
          >
            Delete
          </Link>
        )}
      </div>
    );
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Inventory: Brand</h3> */}
              <ul className="breadcrumb" style={{ marginLeft: "12px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">
                  Manage Master Register
                </li>
              </ul>
            </div>
          </div>
          <div className="d-flex justify-content-between mb-3">
            <div className="col-md-4"></div>
            <div className="page-btn">
              {checkUserPermission(PERMISSION_ADD) ? (
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#ManageDataModal"
                  data-backdrop="static"
                  data-keyboard="false"
                  // className="btn btn-added"
                  className="btn btn-primary btn-sm pull-right"
                  style={{ width: "max-content" }}
                  onClick={() => handleManageDataPopup()}
                >
                  {/* <img src={PlusIcon} alt="img" className="me-1" /> */}
                  <i className="fa fa-plus me-2 lg"></i>
                  Add Master Register
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>

          <div className="card">
            <div className="card-body" style={{ padding: "0px 20px 0 20px" }}>
              <div className="card-body pb-0">
                <div className="table-responsive">
                  <CommonMatrialReactTable
                    columns={columns}
                    data={data}
                    hodiExport={false}
                    enableRowSelection={true}
                    enableRowActions={true}
                    renderRowActions={renderRowActions}
                    isRowSelectionManual={true}
                    setRowSelectData={setRowSelection}
                    setColumnOrder={setColumnOrder}
                    state={{
                      columnOrder,
                      rowSelection,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="ManageDataModal"
        tabIndex={-1}
        aria-labelledby="upset"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="card-title">Manage Master Register</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                // onClick={() => setModal(false)}
              >
                {" "}
                <span aria-hidden="true">×</span>{" "}
              </button>
            </div>
            <div className="modal-body">
              <Formik
                {...props}
                initialValues={formValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({ values, errors, touched, handleChange, handleBlur }) => (
                  <Form>
                    <div className="row">
                      <div className="col-12">
                        <Field
                          type="hidden"
                          className="form-control"
                          id="ID"
                          name="ID"
                          value={values.ID}
                        />
                        <div className="form-group">
                          <label className="col-form-label p-lg-medium">
                            Name
                          </label>
                          <Field
                            type="text"
                            name="Name"
                            className={` ${
                              errors.Name ? "is-invalid" : ""
                            } form-control form-control-sm`}
                            placeholder="Enter Name"
                            value={formValues.Name}
                            onBlur={handleBlur}
                            onChange={(e) => handleInputChange(e)}
                          />
                        </div>
                        <div className="row mb-2">
                          <label className="col-form-label col-md-3 col-form-label p-lg-medium">
                            Location
                          </label>
                          <div className="col-md-12">
                            <Select
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              hideSelectedOptions={true}
                              isClearable={true}
                              placeholder="Select location"
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                              id="LOCATION"
                              name="LOCATION"
                              className="custom-search-select"
                              value={locationDropdownOption?.find(
                                (option) => option?.value == formValues.Location
                              )}
                              options={locationDropdownOption}
                              onChange={(event) => handleLocationChnage(event)}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-12 justify-content-right">
                        <button
                          type="submit"
                          className="btn btn-primary btn-md me-1"
                          // onClick={handlesubmitdata(values.Name)}
                          // onSubmit={(e) => window.history.back()}
                          data-bs-dismiss="modal"
                        >
                          {" "}
                          Submit{" "}
                        </button>
                        <Link
                          to="#"
                          className="btn btn-dark btn-md me-1"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MasterRegister;
